import React, { Component } from 'react';
import treeicon from "../../../Assets/images/treeicon.png";
import moment from "moment-timezone";
import { aboutUsData } from "../../../Assets/data/aboutUsList";

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commercialData: props.commercialData,
      communityRoleData: [
        {
          id: 'board_member',
          name: 'Board Member',
          value: 'board_member'
        },
        {
          id: 'comm_manager',
          name: 'Community Manager',
          value: 'community_manager'
        },
        {
          id: 'conc_resident',
          name: 'Concerned Resident',
          value: 'concerned_resident'
        },
      ],
      preferredContactData: [
        {
          id: 'text',
          name: 'Text',
          value: 'text'
        },
        {
          id: 'home_phone',
          name: 'Home Phone',
          value: 'phone'
        },
        {
          id: 'email',
          name: 'Email',
          value: 'email'
        },
      ],
      communityTypeData: [
        {
          id: 'town_homes',
          name: 'Townhomes',
          value: 'townhomes'
        },
        {
          id: 'detached_homes',
          name: 'Detached Homes',
          value: 'detached'
        },
        {
          id: 'condominium',
          name: 'Condominium',
          value: 'condo'
        },
        {
          id: 'apartment',
          name: 'Apartment',
          value: 'apartment'
        },
      ],
      contactUsData: aboutUsData,
      // contactUsData: [
      //   {
      //     id: 'industry_association',
      //     name: 'Industry Association',
      //     value: 'industry association'
      //   },
      //   {
      //     id: 'referral',
      //     name: 'Referral',
      //     value: 'referral'
      //   },
      //   {
      //     id: 'networking_event',
      //     name: 'Networking Event',
      //     value: 'networking event'
      //   },
      //   {
      //     id: 'presentation',
      //     name: 'Presentation',
      //     value: 'presentation'
      //   },
      //   {
      //     id: 'internet_search',
      //     name: 'Internet Search',
      //     value: 'internet search'
      //   },
      //   {
      //     id: 'advertisement',
      //     name: 'Advertisement',
      //     value: 'advertisement'
      //   },
      //   {
      //     id: 'other',
      //     name: 'Other',
      //     value: 'other'
      //   },
      // ],
      serviceData: [
        {
          id: 'pet_waste_station_service',
          name: 'Pet Waste Station Service',
          value: 'pet_waste_station_service'
        },
        {
          id: 'common_area_cleaning',
          name: 'Common Area Cleaning',
          value: 'common_area_cleaning'
        },
        {
          id: 'trash_can_service',
          name: 'Trash Can Service',
          value: 'trash_can_service'
        },
      ], // step 2
      productData: [
        {
          id: 'pet_waste_stations',
          name: 'Pet Waste Stations',
          value: 'pet_waste_stations'
        },
        {
          id: 'pet_waste_station_bag',
          name: 'Pet Waste Station Bag',
          value: 'pet_waste_station_bags'
        }
      ],
      bagsData: [
        {
          id: 'header_bags',
          name: 'Header Bags',
          value: 'header_bags'
        },
        {
          id: 'roll_bags',
          name: 'Roll Bags',
          value: 'roll_bags'
        },
        {
          id: 'dont_know',
          name: 'I Don’t Know',
          value: 'dont know'
        },
      ],
      stationInstallingData: [
        {
          id: '1-5',
          name: '1-5',
          value: '1-5'
        },
        {
          id: '6-10',
          name: '6-10',
          value: '6-10'
        },
        {
          id: '11-20+',
          name: '11-20+',
          value: '11-20+'
        },
        {
          id: 'dont_know',
          name: 'I Don’t Know',
          value: 'dont_know'
        }
      ],
      serviceFrequencyData: [
        {
          id: 'twice_weekly',
          name: 'Twice Weekly',
          value: 'twice weekly'
        },
        {
          id: 'weekly',
          name: 'Weekly',
          value: 'weekly'
        },
        {
          id: 'every_other_week',
          name: 'Every Other Week',
          value: 'every other week'
        },
        {
          id: 'other',
          name: 'Other',
          value: 'other'
        }
      ],
      cleaningAreasData: [
        {
          id: 'all_common_areas',
          name: 'All Common Areas',
          value: 'all_common_areas'
        },
        {
          id: 'specific_locations',
          name: 'Specific Locations',
          value: 'specific_locations'
        }
      ]
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (JSON.stringify(nextProps?.commercialData) !== JSON.stringify(this.state.commercialData)) {
      this.setState({ commercialData: nextProps.commercialData });
    }
  }

  UNSAFE_componentWillMount = () => {
    this.props.is_footer && window.scrollTo(0,0);
  }

  // on submit request
  onSubmitRequest = () => {
    this.props?.onSubmit && this.props.onSubmit();
  };

  // render info box
  renderInfoBox = (label, text, showImage) => {
    return (
      <div className="contact-info">
        <h4 className="primary">{label}</h4>
        <h5 className="primary d-flex align-items-start">
          {showImage && <img className="mr-2 hide-md" src={treeicon} alt={""} />}
          <span className="">{text}</span>
        </h5>
      </div>
    )
  };

  // render contact info
  renderContactInfo = () => {
    const {
      first_name,
      last_name,
      management_company,
      email_address,
      phone_numbers,
      role,
      reach_out_via,
    } = this.state.commercialData || {};
    const { preferredContactData, communityRoleData } = this.state;

    const contact_number = phone_numbers?.map(obj => obj.phone);
    // eslint-disable-next-line
    const reachOut = reach_out_via?.map(data => {
      const idx = preferredContactData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return preferredContactData[idx]?.name;
      }
    });

    let communityRole = '';
    const idx = communityRoleData?.findIndex(obj => obj.value === role);
    if (idx > -1) {
      communityRole = communityRoleData[idx]?.name;
    }

    return (
      <div className="contact-info">
        <p>{`${first_name} ${last_name}`}</p>
        <p>{communityRole}</p>
        {management_company && <p>{management_company}</p>}
        <p>{email_address}</p>
        <p>{contact_number?.toString()}</p>
        <p>{`Contact By ${reachOut?.toString() || '-'}`}</p>
      </div>
    )
  };

  // render community info
  renderCommunityInfo = () => {
    const {
      management_company,
      properties_in_community,
      home_count,
      would_like_more_info,
      address,
      is_looking_for_proposal
    } = this.state.commercialData || {};

    const { communityTypeData } = this.state
    // eslint-disable-next-line
    const communityProperties = properties_in_community?.map(data => {
      const idx = communityTypeData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return communityTypeData[idx]?.name
      }
    });

    return (
      <div>
        <p>{`${communityProperties?.toString()}${home_count && `, ${home_count}`}`}</p>
        {
          !would_like_more_info && is_looking_for_proposal &&
          <div>
            <p>{address?.address}</p>
            <p>{`${address?.city} ${address?.state}, ${address?.zip_code}`}</p>
            {management_company && <p>{`Managed by ${management_company}`}</p>}
          </div>
        }
      </div>
    )
  };

  // render pet waste info
  renderPetWaste = () => {
    const {
      is_pet_waste_stations_installed,
      existing_pet_waste_stations_count,
      new_pet_waste_stations_interested,
      bag_type,
    } = this.state.commercialData || {};

    const { bagsData, stationInstallingData } = this.state;
    // eslint-disable-next-line
    const bagType = bag_type?.map(data => {
      const idx = bagsData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return bagsData[idx]?.name
      }
    });

    let stationInterested = ''
    const idx = stationInstallingData?.findIndex(obj => obj.value === new_pet_waste_stations_interested);
    if (idx > -1) {
      stationInterested = stationInstallingData[idx]?.name
    }

    return (
      <div>
        <p>{`Pet waste stations`}</p>
        <p>{is_pet_waste_stations_installed ?
          `${existing_pet_waste_stations_count} stations using ${bagType?.toString()}` :
          `${stationInterested} stations are you interested.`
        }</p>
      </div>
    )
  };

  // render trash can info
  renderTrashCan = () => {
    const {
      trash_cans_count,
      is_trash_cans_installed,
      new_trash_cans_interested
    } = this.state.commercialData || {};

    const { stationInstallingData } = this.state;
    let stationInterested = '';
    const idx = stationInstallingData?.findIndex(obj => obj.value === new_trash_cans_interested);
    if (idx > -1) {
      stationInterested = stationInstallingData[idx]?.name
    }

    return (
      <div>
        <p>{`Trash can Service`}</p>
        <p>{is_trash_cans_installed ?
          `${trash_cans_count} stations` :
          `${stationInterested} stations are you interested.`
        }</p>
      </div>
    )
  };

  // render service frequency data
  renderServiceFrequencyData = () => {
    const {
      current_frequency,
    } = this.state.commercialData || {};

    const { serviceFrequencyData } = this.state;

    let currentfrequency = ''
    const idx = serviceFrequencyData?.findIndex(obj => obj.value === current_frequency);
    if (idx > -1) {
      currentfrequency = serviceFrequencyData[idx]?.name
    }

    return (
      <div>
        <p>{`${currentfrequency} Service`}</p>
      </div>
    )
  };

  // render cleaning area
  renderCleaningArea = () => {
    const {
      areas_to_clean
    } = this.state.commercialData || {};

    const { cleaningAreasData } = this.state;
    let area = ''
    const idx = cleaningAreasData?.findIndex(obj => obj.value === areas_to_clean);
    if (idx > -1) {
      area = cleaningAreasData[idx]?.name
    }

    return (
      <div>
        <p>{`Common area cleaning`}</p>
        <p>{`${area?.toString()}`}</p>
      </div>
    )
  };

  // render proposal date
  renderProposalDate = () => {
    const {
      is_looking_for_proposal,
      proposal_due
    } = this.state.commercialData || {};

    return (
      <div>
        <p>{`${is_looking_for_proposal ? moment(proposal_due)?.format('YYYY-MM-DD') : '-'}`}</p>
      </div>
    )
  }

  // render service need
  renderServiceNeed = () => {
    const {
      interested_services,
      is_trash_cans_installed,
      is_pet_waste_stations_installed,
      interested_products
    } = this.state.commercialData || {};

    const { productData } = this.state;
    // eslint-disable-next-line
    const products = interested_products?.map(data => {
      const idx = productData?.findIndex(obj => obj.value === data);
      if (idx > -1) {
        return productData[idx]?.name
      }
    });

    const isPetWasteStation = interested_services?.includes("pet_waste_station_service");
    const isCommonCleaningArea = interested_services?.includes("common_area_cleaning");
    const isTrashCan = interested_services?.includes("trash_can_service");

    return (
      <div>
        {isPetWasteStation && this.renderPetWaste()}
        {isTrashCan && this.renderTrashCan()}
        {((isTrashCan && is_trash_cans_installed) || (isPetWasteStation && is_pet_waste_stations_installed)) && this.renderServiceFrequencyData()}
        {isCommonCleaningArea && this.renderCleaningArea()}
        <p>{`Products needed: ${products?.toString() || '-'}`}</p>
      </div>
    )
  };

  render() {
    const {is_footer} = this.props;
    return (
      <React.Fragment >
        <div className="sidebar common_sidebar register-sidebar">
          <h2 className="primary hide-md">{is_footer ? 'Community information summary' : 'Community Summary' }</h2>
          <h5 className="primary">{this.renderInfoBox('Contact information', this.renderContactInfo())}</h5>
          <hr />
          <h5 className="primary">{this.renderInfoBox('Community information', this.renderCommunityInfo())}</h5>
          <span></span>
          <hr />
          <h5 className="primary d-flex align-items-start">{this.renderInfoBox('Service needs', this.renderServiceNeed(), true)}</h5>
          <hr />
          <h5 className="primary">{this.renderInfoBox('Date Proposal due', this.renderProposalDate())}</h5>
        </div>
        {is_footer &&
          <div>
            <div className="sidebar_note"><p>Questions about your quote? Call us at <a href="/#" >1-800-366-3922</a> and we’ll walk you through it. We’re available Mon-Fri from 8AM to 9PM. Or <a href="/#">email</a> us any time!</p></div>
            <div className="submit_btn mobile_continue_btn">
              <button type="button" onClick={() => this.onSubmitRequest()} className="btn">Submit Request</button>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }
}

export default Sidebar;